export default "__VITE_ASSET__BrubUeGZ__"